import cloneDeep from 'lodash/cloneDeep';

class Purchase {
  constructor({PeriodWasterTests, PeriodPurchases, LifeTimePurchases, AvgPurchasePerAnalysis, ThreeStepPurchase, Purchases}) {
    this.PeriodWasterTests = PeriodWasterTests;
    this.PeriodPurchases = PeriodPurchases;
    this.LifeTimePurchases = LifeTimePurchases;
    this.AvgPurchasePerAnalysis = AvgPurchasePerAnalysis;
    this.ThreeStepPurchase = ThreeStepPurchase;
    this.Purchases = Purchases;
  }

  clone() {
    return cloneDeep(this);
  }

  static fromApiFormat(api) {

    return new Purchase({
      PeriodWasterTests: api.PeriodWasterTests,
      PeriodPurchases: api.PeriodPurchases,
      LifeTimePurchases: api.LifeTimePurchases,
      AvgPurchasePerAnalysis: api.AvgPurchasePerAnalysis,
      ThreeStepPurchase: api.ThreeStepPurchase,
      Purchases: api.Purchases,
    });
  }
}

export default Purchase;
